/**
 *
 * @module thumbnailSet
 *
 */

import Check from 'check-types';

import Exception from './../exception/entry';

import Presentation from './presentation';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyObject,
    number,
    array
} = Check.assert;

/**
 *
 * @class ThumbnailSet
 *
 */
export default class ThumbnailSet {

    /**
     *
     * @param {Object} options
     * @param {Number} options.thumbnailWidth
     * @param {Number} options.thumbnailHeight
     * @param {Number} options.intervalMilliseconds
     * @param {Number} options.totalBytes
     * @param {Array<SDK.Services.Media.Presentation>} options.presentations
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: `${this.constructor.name}(options)`,
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get thumbnailWidth() {
                return `${this.ctor} options.thumbnailWidth should be a Number`;
            },
            get thumbnailHeight() {
                return `${this.ctor} options.thumbnailHeight should be a Number`;
            },
            get intervalMilliseconds() {
                return `${this.ctor} options.intervalMilliseconds should be a Number`;
            },
            get totalBytes() {
                return `${this.ctor} options.totalBytes should be a Number`;
            },
            get presentations() {
                return `${this.ctor} options.presentations should be an Array of SDK.Services.Media.Presentation`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { thumbnailWidth, thumbnailHeight, intervalMilliseconds, totalBytes, presentations } = options;

        number(thumbnailWidth, errorMessage.thumbnailWidth, InvalidArgumentException);
        number(thumbnailHeight, errorMessage.thumbnailHeight, InvalidArgumentException);
        number(intervalMilliseconds, errorMessage.intervalMilliseconds, InvalidArgumentException);
        number(totalBytes, errorMessage.totalBytes, InvalidArgumentException);
        array.of.instanceStrict(presentations, Presentation, options.presentations, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         * @desc The x resolution for each thumbnail
         *
         */
        this.thumbnailWidth = thumbnailWidth;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The y resolution for each thumbnail
         *
         */
        this.thumbnailHeight = thumbnailHeight;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The amount of media time between each thumbnail
         *
         */
        this.intervalMilliseconds = intervalMilliseconds;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The total download size of all thumbnails at this resolution. This is the sum of the sizes of all of
         * the spritesheets or all of the bifs supplied for a given resolution
         *
         */
        this.totalBytes = totalBytes;

        /**
         *
         * @access public
         * @type {Array<SDK.Services.Media.Presentation>}
         * @desc A list of presentations for this resolution
         *
         */
        this.presentations = presentations;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/thumbnailSet.js